export default {
  items: [
    {
      name: 'Home',
      url: '/',
      icon: 'icon-home',
    },
    {
      name: 'Applications',
      url: '/applications',
      icon: 'icon-puzzle',
      permissions: [
        {
          admin: {
            applications: [1]
          }
        }
      ]
    },
    {
      name: 'Briefcase',
      url: '/briefcase',
      icon: 'icon-briefcase',
      permissions: [{admin: {briefcase: [1]}}]
    },
    {
      name: 'Calendar',
      url: '/calendar',
      icon: 'icon-calendar',
      permissions: [{admin: {calendar: [1]}}]
    },
    {
      name: 'Cameras',
      url: '/cameras',
      icon: 'icon-camrecorder',
      permissions: [{admin: {cameras: [1]}}]
    },
    {
      name: 'Careers',
      url: '/careers',
      icon: 'icon-cursor',
      permissions: [{admin: {careers: [1]}}, {admin: {careers: [2]}}, {admin: {careers: [3]}}],
      children: [
        {
          name: 'Applicants',
          url: '/careers/applicants',
          icon: 'icon-cursor',
          permissions: [{admin: {careers: [1]}}, {admin: {careers: [2]}}],
        },
        {
          name: 'Access',
          url: '/careers/access',
          icon: 'icon-cursor',
          permissions: [{admin: {careers: [2]}}, {admin: {careers: [3]}}],
        }
      ]
    },
    {
      name: 'Debt Calculator',
      url: '/debtcalc',
      icon: 'icon-calculator',
      permissions: [{admin: {cameras: [1]}}]
    },
    {
      name: 'Events',
      url: '/events',
      icon: 'icon-calendar',
      permissions: [{admin: {events: [1]}}]
    },
    {
      name: 'Marketing Manager',
      url: '/leads/',
      icon: 'cil-address-book',
      permissions: [{admin: {lms: [1]}}],
    },
    {
      name: 'Lookup',
      url: '/lookup',
      icon: 'cil-search',
      permissions: [{admin: {lms: [1]}}],
      children: [

        {
          name: 'Intakes',
          url: '/lookup/intakes',
          icon: 'cil-contact',
          permissions: [{admin: {intakes: [1]}}],
        },
        {
          name: 'Client Info',
          url: '/lookup/search',
          icon: 'cil-contact',
          permissions: [{admin: {lms: [1]}}],
        },
        {
          name: 'Policy Data',
          url: '/lookup/policies',
          icon: 'cil-spreadsheet',
          permissions: [{admin: {lms: [1]}}],
        },
      ]
    },
    {
      name: 'Store',
      url: '/store',
      icon: 'cil-store',
      permissions: [{admin: {store: [1]}}],
    },
    {
      name: 'Resource Center',
      url: '/resources',
      icon: 'cil-spreadsheet',
      permissions: [{admin: {resources: [1]}}],
    },
    {
      name: 'Review Center',
      url: '/reviews',
      icon: 'cil-chat-bubble',
      permissions: [{admin: {reviews: [1]}}],
    },
    {
      name: 'Tax Center',
      url: '/taxes',
      icon: 'cil-cash',
      permissions: [{admin: {taxes: [1]}}],
    },
    {
      name: 'TimeClock',
      url: '/timeclock',
      icon: 'cil-clock',
      permissions: [{admin: {timeclock: [1]}}],
    },
    {
      name: 'Training Center',
      url: '/training',
      icon: 'cil-movie',
      permissions: [{admin: {training: [1]}}],
    },
    {
      name: 'Administration',
      url: '/admin',
      icon: 'icon-puzzle',
      permissions: [
        {admin: {applications: [4]}},
        {admin: {users: [1]}},
        {admin: {splash: [2],}},
        {admin: {timeclock: [2]}}
      ],
      children: [
        {
          name: 'Banners',
          url: '/admin/banners',
          icon: 'icon-images',
          permissions: [
            {
              admin: {
                splash: [2],
              }
            }
          ],
        },
        {
          name: 'TimeClock',
          url: '/timeclock/-1',
          icon: 'cil-clock',
          permissions: [{admin: {timeclock: [2]}}],
        },
        {
          name: 'Users',
          url: '/admin/users',
          icon: 'icon-cursor',
          permissions: [
            {
              admin: {
                users: [4],
              }
            }
          ],
        }
      ]
    },
    {
      name: 'Old Portal',
      url: '/sso/A45nbkF9DlskZjkdjgJkfmdmTnmtnjDFk98ojiFo4t9u8joiOJIGIJOGreoi345otjis98s34rtoKLFGkleostjWhisgGRIURtgisaeo',
      icon: 'icon-cursor',
      permissions: [{admin: {oldportal: [1]}}]
    },
    {
      name: 'Logout',
      url: '/logout',
      icon: 'fa fa-circle text-danger',
      label: {
        variant: 'danger'
      },
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js